import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "ç¼ç»",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path 129",
				d: "M3.3125 4.97909H16.6458",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path 129_2",
				d: "M3.3125 9.97909H16.6458",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path 129_3",
				d: "M3.3125 14.9791H16.6458",
				stroke: "",
				strokeWidth: 1.4,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgMenu;
